export default __webpack_public_path__ + "static/media/puspakam.330d3e8a.png";